(() => {
  'use strict';
  if (window.CasemetaStorefront) return;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const key = 'casemeta:model:v1';
  const clean = (label) => (typeof label === 'string' ? label : '').replace(/\s*—\s*Tükendi$/, '').trim();
  const safeRead = () => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
  let remembered = safeRead();
  let effective = remembered;
  let quickRequest = 0;
  let quickAbort;
  let quickProduct;
  let quickSelection = {};
  let toastTimer;
  const cache = new Map();
  const designCache = new Map();
  let recommendationRequest = 0;
  const rootUrl = window.Shopify?.routes?.root || '/';
  function previewUrl(path) {
    const url = new URL(path, location.href);
    if (url.origin !== location.origin) return url;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    const theme = window.Shopify?.theme;
    const id = theme && theme.role !== 'main' ? theme.id : preview;
    if (id) url.searchParams.set('preview_theme_id', id);
    return url;
  }
  function modelByLabel(label) {
    const button = $$('[data-cm-model-value]').find(b => b.dataset.cmModelValue === clean(label));
    return button ? { label: button.dataset.cmModelValue, param: button.dataset.cmModelParam, tag: button.dataset.cmModelTag, collection: button.dataset.cmModelCollection } : null;
  }
  function designUrl(link) {
    const current = previewUrl(link.href);
    if (current.origin !== location.origin || !effective?.collection || !/^iPhone\b/.test(effective.label)) return;
    const route = (window.CasemetaDesignRoutes || []).find(([path]) => new URL(path, location.origin).pathname === (link.dataset.cmDesignSource || current.pathname));
    if (!route) return;
    link.dataset.cmDesignSource = new URL(route[0], location.origin).pathname;
    current.pathname = new URL(effective.collection, location.origin).pathname;
    for (const key of [...current.searchParams.keys()]) if (['cm_model','sort_by','page'].includes(key) || key.startsWith('filter.')) current.searchParams.delete(key);
    current.searchParams.set('view', route[1]);
    link.href = current.href;
  }
  function saveModel(model) {
    remembered = effective = model;
    try { if (model) localStorage.setItem(key, JSON.stringify(model)); else localStorage.removeItem(key); } catch { /* Browsing remains usable without storage. */ }
    paintModel();
    $$('a[href]').forEach(designUrl);
    document.dispatchEvent(new CustomEvent('cm:model:change', {detail: model}));
  }
  function paintModel() {
    $$('[data-cm-model-label]').forEach(el => { el.textContent = effective ? `${effective.label} · Değiştir` : 'Telefon modelini seç'; });
    $$('[data-cm-model-value]').forEach(el => el.setAttribute('aria-current', String(el.dataset.cmModelValue === effective?.label)));
  }
  const manualCaseCollections = {Power:'/collections/power','Clear MagSafe':'/collections/clear-magsafe','Ultra Silikon':'/collections/ultra-silikon-iphone'};
  function caseCollection(model, type, sort = 'manual') {
    // Only the iPhone case catalogue's All tab uses the merchant's type order.
    return sort === 'manual' && model?.param === 'filter.p.m.custom.iphone_models'
      ? manualCaseCollections[(type || '').replace(/ Kılıf$/, '').trim()] : null;
  }
  function modelUrl(path, model) {
    const url = previewUrl(path);
    [...url.searchParams.keys()].filter(k => /filter\.p\.m\.custom\.(iphone_models|galaxy_models|xiaomi_model|oppo_model|diger_model|honor_model|realme_model|tecno_model|vivo_model)$/.test(k)).forEach(k => url.searchParams.delete(k));
    url.searchParams.delete('page');
    const collectionPath = url.pathname.match(/^(.*\/collections\/[^/]+)(?:\/([^/]+))?$/);
    if (collectionPath) {
      const tags = (collectionPath[2] || '').split('+').filter(t => t && !/^jm[_-]model[_-]/i.test(t));
      const base = $('#cm-model-dialog')?.dataset.cmCaseBase;
      if (collectionPath[1] === base && !tags.includes($('#cm-model-dialog').dataset.cmCaseTag)) tags.push($('#cm-model-dialog').dataset.cmCaseTag);
      url.pathname = collectionPath[1] + (tags.length ? '/' + tags.join('+') : '');
    }
    if (model) url.searchParams.set(model.param, model.label);
    const base = $('#cm-model-dialog')?.dataset.cmCaseBase;
    const baseTag = $('#cm-model-dialog')?.dataset.cmCaseTag;
    // A copied/ad URL renders the explicit model on the server. Links marked to
    // apply the remembered phone still resolve to that phone before navigation.
    const nativeEntry = url.origin === location.origin && url.searchParams.get('view') === 'cm-cases' &&
      (Object.values(manualCaseCollections).includes(url.pathname) || $$('[data-cm-model-collection]').some(button => button.dataset.cmModelCollection && new URL(button.dataset.cmModelCollection, location.origin).pathname === url.pathname));
    if (model?.collection && (url.pathname === base || url.pathname === base + '/' + baseTag || nativeEntry)) {
      let storedType;try { storedType=localStorage.getItem('casemeta:case:v1'); } catch {}
      const type=url.searchParams.get('cm_type') || storedType || url.searchParams.get('filter.p.m.custom.iphone_kiliflar') || 'Power';
      url.pathname=new URL(caseCollection(model,type,url.searchParams.get('sort_by') || 'manual') || model.collection,location.origin).pathname;
      url.searchParams.set('view','cm-cases');
      url.searchParams.set('filter.p.m.custom.iphone_kiliflar',type);
      if(url.searchParams.get('cm_color')) url.searchParams.set('filter.v.option.renk',url.searchParams.get('cm_color'));
      if(!url.searchParams.has('sort_by')) url.searchParams.set('sort_by','manual');
    }
    return url;
  }
  function openDialog(id, opener) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    dialog.cmOpener = opener || document.activeElement;
    if (id === 'cm-model-dialog') filterModels();
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
  }
  function caseImages(media, dialog, signal, currentType) {
    const cache = new Map();
    let timer, idle;
    const url = (src, width) => { const value = new URL(src, location.origin); value.searchParams.set('width', width); return value.href; };
    function get(type, kind, priority = 'auto', slot = '') {
      const key = `${type}:${kind}:${slot}`;
      if (cache.has(key)) { const image = cache.get(key); image.fetchPriority = priority; return image; }
      const source = media[type]?.[kind], artwork = kind === 'detail';
      const image = document.createElement('img'), width = kind === 'thumb' ? 180 : artwork ? 1200 : 400;
      image.alt = kind === 'thumb' ? '' : `${type}${artwork ? ' özellikleri' : ''}`;
      image.width = artwork ? source.width : width; image.height = artwork ? source.height : width;
      image.loading = 'eager'; image.decoding = 'async'; image.fetchPriority = priority;
      if (artwork) {
        image.className = 'cm-case-detail-art';
        image.sizes = '(max-width: 749px) calc(100vw - 32px), 592px';
        image.srcset = [360,640,960,1200].map(w => `${url(source.src,w)} ${w}w`).join(',');
      }
      if (source) image.src = url(artwork ? source.src : source, width);
      cache.set(key, image);
      return image;
    }
    function prepare(intent = false) {
      if (signal.aborted || !dialog.isConnected) return;
      const types = Object.keys(media).sort((a,b) => Number(b === currentType()) - Number(a === currentType()));
      types.forEach(type => {
        const kinds = ['thumb', media[type]?.detail ? 'detail' : 'fallback'];
        kinds.forEach(kind => {
          if (!media[type]?.[kind]) return;
          const image = get(type, kind, intent ? 'auto' : 'low');
          image.decode?.().catch(() => {});
        });
      });
    }
    // Keep the main page first. These six shared images are useful only after
    // the initial page load or when the shopper shows intent to open the panel.
    const schedule = () => {
      if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
      timer = setTimeout(() => {
        if ('requestIdleCallback' in window) idle = requestIdleCallback(() => prepare(), { timeout: 1000 });
        else prepare();
      }, 150);
    };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true, signal });
    document.querySelectorAll(`[data-cm-open="${dialog.id}"]`).forEach(button => {
      ['pointerenter','pointerdown','focusin'].forEach(type => button.addEventListener(type, () => prepare(true), { signal, passive: true }));
    });
    signal.addEventListener('abort', () => { clearTimeout(timer); if (idle !== undefined) cancelIdleCallback(idle); cache.clear(); }, { once: true });
    return { get };
  }
  function toast(text) {
    const element = $('[data-cm-toast]');
    element.textContent = text;
    element.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { element.hidden = true; }, 4000);
  }
  function initializeDialogs(scope = document) {
    $$('dialog.cm-dialog', scope).forEach(dialog => {
      if (dialog.cmReady) return;
      dialog.cmReady = true;
      dialog.addEventListener('close', () => {
        if (!$('dialog[open]')) document.documentElement.style.overflow = '';
        dialog.cmOpener?.focus?.({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
      });
    });
  }
  function initializeRails(scope = document) {
    $$('[data-cm-rail]', scope).forEach(rail => {
      if (rail.cmReady) return;
      rail.cmReady = true;
      const dots = rail.parentElement.querySelector('[data-cm-dots]');
      let stops = [];
      let frame;
      let layoutFrame;
      let geometry = '';
      const active = () => {
        const index = stops.reduce((best, x, i) => Math.abs(x - rail.scrollLeft) < Math.abs(stops[best] - rail.scrollLeft) ? i : best, 0);
        dots && [...dots.children].forEach((d, i) => d.setAttribute('aria-current', String(i === index)));
      };
      const layout = () => {
        if (!dots) return;
        // A rail can temporarily have zero width while its section is laid out.
        // Never use a live or zero measurement as a loop increment.
        const width = rail.clientWidth;
        const end = Math.max(0, rail.scrollWidth - width);
        const nextGeometry = `${width}:${end}:${rail.children.length}`;
        if (geometry === nextGeometry) return;
        geometry = nextGeometry;
        if (width <= 0 || !Number.isFinite(width) || !Number.isFinite(end)) {
          stops = []; dots.hidden = true; dots.replaceChildren(); return;
        }
        stops = [0];
        for (let offset = width; offset < end && stops.length < 99; offset += width) stops.push(offset);
        if (end > 4) stops.push(end);
        dots.hidden = end <= 4;
        dots.replaceChildren(...stops.map((left, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `${i + 1}. görsel grubunu göster`);
          button.addEventListener('click', () => rail.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
          return button;
        }));
        active();
      };
      const onScroll = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(active); };
      rail.addEventListener('scroll', onScroll, { passive: true });
      const resize = new ResizeObserver(() => {
        cancelAnimationFrame(layoutFrame);
        layoutFrame = requestAnimationFrame(layout);
      });
      resize.observe(rail);
      rail.cmCleanup = () => { resize.disconnect(); cancelAnimationFrame(frame); cancelAnimationFrame(layoutFrame); rail.removeEventListener('scroll', onScroll); };
      layout();
    });
  }
  async function loadProduct(path, signal) {
    const url = previewUrl(path);
    url.searchParams.delete('variant');
    url.searchParams.set('section_id', 'cm-quick-product');
    const identity = url.href;
    if (cache.has(identity)) return new DOMParser().parseFromString(cache.get(identity), 'text/html');
    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error('Ürün seçenekleri şu anda yüklenemedi.');
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    if (!$('[data-cm-quick-content]', doc)) throw new Error('Ürün seçenekleri bulunamadı.');
    cache.set(identity, text);
    return doc;
  }
  function optionFor(select, label) {
    return select && [...select.options].find(option => clean(option.textContent) === clean(label));
  }
  async function openQuick(path, opener, selection = {}) {
    quickSelection = selection;
    const dialog = $('#cm-quick-dialog');
    if (!dialog.open) openDialog('cm-quick-dialog', opener);
    const body = $('[data-cm-quick-body]');
    body.textContent = 'Seçenekler yükleniyor…';
    quickAbort?.abort();
    quickAbort = new AbortController();
    const request = ++quickRequest;
    try {
      let doc = await loadProduct(path, quickAbort.signal);
      if (request !== quickRequest) return;
      let content = $('[data-cm-quick-content]', doc);
      const initialModel = $('[data-cm-quick-axis="model"]', content);
      const target = content.dataset.phoneModel === 'true' && effective && optionFor(initialModel, effective.label);
      if (target && new URL(target.value, location.origin).pathname !== content.dataset.url) {
        doc = await loadProduct(target.value, quickAbort.signal);
        if (request !== quickRequest) return;
        content = $('[data-cm-quick-content]', doc);
      }
      quickProduct = JSON.parse($('[data-cm-quick-data]', content).textContent);
      body.replaceChildren(content);
      const modelSelect = $('[data-cm-quick-axis="model"]', content);
      if (modelSelect) {
        if (content.dataset.phoneModel === 'true') {
          const match = effective && optionFor(modelSelect, effective.label);
          modelSelect.value = match?.value || '';
          if (effective && !match) $('[data-cm-quick-error]', content).textContent = `Bu tasarım ${effective.label} için bulunmuyor. Başka model seçebilirsin.`;
        } else if (!selection.model) modelSelect.value = '';
      }
      $$('[data-cm-quick-axis]', content).filter(s => s.dataset.cmQuickAxis !== 'model').forEach(s => {
        if (!selection[s.dataset.cmQuickAxis] && s.options.length > 2) s.value = '';
      });
      const optionsRoot = $('[data-cm-quick-options]', content);
      if (!(quickProduct.options.length === 1 && (quickProduct.options[0].name || quickProduct.options[0]) === 'Title')) {
        quickProduct.options.forEach((option, index) => {
          const name = option.name || option;
          const values = [...new Set(quickProduct.variants.map(v => v.options[index]))];
          const label = document.createElement('label'); label.className = 'cm-field'; label.textContent = name;
          const select = document.createElement('select'); select.required = true; select.dataset.cmQuickVariantOption = String(index);
          select.add(new Option(`${name} seç`, ''));
          values.forEach(value => select.add(new Option(value, value)));
          select.dataset.optionName = name;
          select.value = values.length === 1 ? values[0] : (values.includes(selection.options?.[name]) ? selection.options[name] : '');
          label.append(select); optionsRoot.append(label);
        });
      }
      $$('a[href]', content).forEach(a => { a.href = previewUrl(a.getAttribute('href')).href; });
      updateQuickVariant();
    } catch (error) {
      if (error.name === 'AbortError' || request !== quickRequest) return;
      body.textContent = error.message;
      const link = document.createElement('a'); link.className = 'cm-button'; link.href = previewUrl(path); link.textContent = 'Ürün sayfasını aç'; body.append(link);
    }
  }
  function selectedVariant() {
    const options = $$('[data-cm-quick-variant-option]').map(s => s.value);
    if (options.some(v => !v)) return null;
    return quickProduct?.variants.find(v => options.length === 0 || v.options.every((value, i) => value === options[i]));
  }
  function updateQuickVariant() {
    const variant = selectedVariant();
    const button = $('[data-cm-quick-add]');
    if (!button) return;
    const chosen = $$('[data-cm-quick-variant-option]').every(s => s.value);
    button.disabled = chosen && (!variant || !variant.available);
    button.textContent = chosen && !variant?.available ? 'Tükendi' : 'Sepete ekle';
    if (variant) $('[data-cm-quick-price]').textContent = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.Shopify?.currency?.active || 'TRY' }).format(variant.price / 100);
  }
  async function readyCart() {
    const cart = $('cart-drawer') || $('cart-notification');
    if (cart && !cart.renderContents && !customElements.get(cart.localName)) {
      // Collection controls can run before Dawn. An early add must still use
      // the drawer's sections and focus handling once its element is defined.
      await new Promise(resolve => {
        const timer = setTimeout(resolve, 5000);
        customElements.whenDefined(cart.localName).then(() => { clearTimeout(timer); resolve(); });
      });
    }
    return $('cart-drawer') || $('cart-notification');
  }
  async function addQuick(button) {
    const content = $('[data-cm-quick-content]');
    const error = $('[data-cm-quick-error]');
    error.textContent = '';
    if (content.dataset.personalized === 'true') return;
    const missing = $$('select', content).find(s => !s.value);
    if (missing) { error.textContent = 'Lütfen model ve ürün seçeneklerini tamamla.'; missing.focus(); missing.reportValidity(); return; }
    const variant = selectedVariant();
    if (!variant?.available) { error.textContent = 'Bu seçenek şu anda stokta bulunmuyor.'; return; }
    button.disabled = true; button.textContent = 'Ekleniyor…';
    try {
      const drawer = await readyCart();
      const sections = drawer?.getSectionsToRender?.().map(s => s.id) || ['cart-icon-bubble'];
      const response = await fetch(`${rootUrl}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: variant.quantity_rule?.min || 1 }], sections, sections_url: location.pathname }) });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'Ürün sepete eklenemedi.');
      closeDialog($('#cm-quick-dialog'));
      if (drawer?.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      else { const link = document.createElement('a'); link.href = `${rootUrl}cart`; link.click(); }
      if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'casemeta-quick-add', productVariantId: variant.id, cartData: data });
    } catch (e) { error.textContent = e.message; }
    finally { button.disabled = false; button.textContent = 'Sepete ekle'; }
  }
  async function addDirect(button) {
    if (button.disabled || button.dataset.cmAdding) return;
    const id = Number(button.dataset.cmDirectAdd);
    if (!Number.isSafeInteger(id) || id <= 0) return;
    button.dataset.cmAdding = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true');
    try {
      const drawer = await readyCart();
      const sections = drawer?.getSectionsToRender?.().map(s => s.id) || ['cart-icon-bubble'];
      drawer?.setActiveElement?.(button);
      const response = await fetch(`${rootUrl}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: Math.max(1, Number(button.dataset.cmQuantity) || 1) }], sections, sections_url: location.pathname }) });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'Ürün sepete eklenemedi.');
      if (drawer?.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      else { const link = document.createElement('a'); link.href = `${rootUrl}cart`; link.click(); }
      if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'casemeta-collection-add', productVariantId: id, cartData: data });
    } catch (error) { toast(error.message); }
    finally { delete button.dataset.cmAdding; button.disabled = false; button.removeAttribute('aria-busy'); }
  }
  function productModel() { return $('casemeta-product-navigation')?.dataset.model; }
  function confirmProductModel() {
    const actual = modelByLabel(productModel());
    if (!actual || effective?.label === actual.label) return true;
    const note = $('[data-cm-product-model-note]');
    if (note) { note.hidden = false; note.scrollIntoView({ block: 'center', behavior: 'smooth' }); $('button', note)?.focus(); }
    return false;
  }
  async function productLink(link, event) {
    if (!effective || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const card = link.closest('[data-cm-product-card]');
    // Cards already carry their exact phone model. Keep native navigation when
    // it matches the current selection; unknown/mismatched cards still resolve
    // their compatible product through the existing quick-product request.
    if (card?.dataset.model === effective.label && card.dataset.productUrl) {
      const cardUrl = new URL(card.dataset.productUrl, location.origin);
      const linkUrl = new URL(link.href, location.origin);
      if (linkUrl.origin === location.origin && cardUrl.origin === location.origin && cardUrl.pathname === linkUrl.pathname) return;
    }
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    try {
      const doc = await loadProduct(link.href);
      const select = $('[data-cm-quick-content][data-phone-model="true"] [data-cm-quick-axis="model"]', doc);
      const option = optionFor(select, effective.label);
      if (select && !option) { await openQuick(link.href, link); return; }
      const destination = previewUrl(option?.value || link.href);
      const clicked = new URL(link.href);
      if (clicked.pathname === destination.pathname && clicked.searchParams.has('variant')) destination.searchParams.set('variant',clicked.searchParams.get('variant'));
      location.assign(destination);
    } catch { location.assign(previewUrl(link.href)); }
    finally { link.removeAttribute('aria-busy'); }
  }
  async function fillRecommendations() {
    const ticket = ++recommendationRequest;
    const target = $('[data-cm-other-designs]');
    const featured = $('[data-cm-featured]');
    const model = modelByLabel(productModel()) || effective;
    if (target && model && target.dataset.collection) {
      const rail = $('[data-cm-rail]', target), status = $('[data-cm-recommend-status]', target);
      rail.setAttribute('aria-busy', 'true');
      if (!rail.children.length) status.textContent = 'Diğer tasarımlar yükleniyor…';
      try {
        const currentName = $('product-info h1')?.textContent.trim();
        const cards = (await designCards(target.dataset.collection, model)).filter(card => new URL(card.dataset.productUrl, location.origin).pathname !== location.pathname && $('h3', card)?.textContent.trim() !== currentName).slice(0,8);
        if (ticket !== recommendationRequest || !target.isConnected) return;
        rail.replaceChildren(...cards);
        status.textContent = cards.length ? '' : 'Bu model için başka tasarım bulunamadı.';
        rail.cmCleanup?.(); rail.cmReady = false; initializeRails(target);
      } catch {
        if (ticket === recommendationRequest && target.isConnected) status.textContent = 'Diğer tasarımlar şu anda yüklenemedi.';
      } finally {
        if (ticket === recommendationRequest && target.isConnected) rail.setAttribute('aria-busy', 'false');
      }
    }
    if (featured && effective) {
      try {
        const cards = (await designCards(featured.dataset.collectionUrl, effective)).slice(0,8);
        if (ticket !== recommendationRequest || !featured.isConnected) return;
        cards.forEach(c => $$('.cm-card__price,.cm-card__action', c).forEach(el => el.remove()));
        const rail = $('[data-cm-rail]', featured); rail.replaceChildren(...cards);
        featured.hidden = cards.length === 0;
        rail.cmCleanup?.(); rail.cmReady = false; initializeRails(featured);
      } catch { /* Keep the server-rendered discovery list; link handling still checks compatibility. */ }
    }
  }
  function initializeCollection() {
    const api = {getModel: () => effective, modelByLabel, saveModel, previewUrl, openDialog, closeDialog, caseImages, caseCollection};
    window.CasemetaCollections?.init(api);
    window.CasemetaAllProducts?.init(api);
  }
  function searchUrl(model, page = 1, query = '*') {
    const url = modelUrl(`${rootUrl}search`, model);
    url.searchParams.set('q', query); url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', 'cm-model-search'); url.searchParams.set('page', page);
    return url;
  }
  async function searchCollectionPage(collection, model, page, query = '*') {
    const response = await fetch(searchUrl(model, page, query));
    if (!response.ok) throw new Error('Modeller yüklenemedi.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const result = $('[data-cm-model-search-results]', doc);
    if (!result) throw new Error('Modeller yüklenemedi.');
    const cards = $$('[data-cm-search-item]', result).filter(item => item.dataset.collections.includes(`|${collection}|`)).map(item => $('[data-cm-product-card]', item)).filter(card => card && card.dataset.model === model.label);
    return { cards, next: !!result.dataset.next };
  }
  async function designCards(path, model) {
    const source = previewUrl(path), base = $('#cm-model-dialog')?.dataset.cmCaseBase;
    const basePath = base && new URL(base, location.origin).pathname;
    const caseTag = $('#cm-model-dialog')?.dataset.cmCaseTag;
    // The full catalog is too large for Shopify's collection filters. A model's
    // existing collection gives the same compatible range in one request.
    const modelSource = model.collection && basePath && (source.pathname === basePath || source.pathname === `${basePath}/${caseTag}`);
    const url = modelUrl(modelSource ? model.collection : path, model);
    if (modelSource) url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('section_id', 'cm-design-results');
    const key = url.href;
    if (!designCache.has(key)) {
      if (designCache.size >= 8) designCache.delete(designCache.keys().next().value);
      const pending = loadDesignCards(url, model).catch(error => {
        if (designCache.get(key) === pending) designCache.delete(key);
        throw error;
      });
      designCache.set(key, pending);
    }
    // Each render owns its nodes; reusing cached data never moves another rail.
    return (await designCache.get(key)).map(card => card.cloneNode(true));
  }
  async function loadDesignCards(url, model) {
    const response = await fetch(url); if (!response.ok) throw new Error('Tasarımlar yüklenemedi.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const result = $('[data-cm-design-results]', doc);
    if (!result) throw new Error('Tasarım verisi bulunamadı.');
    if (Number(result.dataset.total) <= 5000) return $$('[data-cm-product-card]', doc).filter(card => card.dataset.model === model.label);
    const cards = [], seen = new Set();
    for (let page = 1; page <= 3 && cards.length < 8; page++) {
      const resultPage = await searchCollectionPage(result.dataset.collection, model, page);
      resultPage.cards.forEach(card => { const name = $('h3', card).textContent.trim(); if (!seen.has(name)) { seen.add(name); cards.push(card); } });
      if (!resultPage.next) break;
    }
    return cards;
  }
  function initializeSticky() {
    const bar = $('[data-cm-sticky]');
    const button = $('product-info product-form [name="add"]');
    if (!bar || !button) return;
    bar.cmCleanup?.();
    const observer = new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
    observer.observe(button);
    const price = $('product-info [id^="price-"]');
    const refresh = () => {
      const actualPrice = price && ($('.price-item--sale', price)?.closest('.price--on-sale') ? $('.price-item--sale', price) : $('.price-item--regular', price));
      const stickyPrice = $('[data-cm-sticky-price]');
      if (actualPrice && stickyPrice.textContent !== actualPrice.textContent.trim()) stickyPrice.textContent = actualPrice.textContent.trim();
      const stickyButton = $('[data-cm-sticky-add]');
      const label = button.disabled ? ($('span', button)?.textContent.trim() || 'Seçenekleri tamamla') : 'Sepete ekle';
      if (stickyButton.textContent !== label) stickyButton.textContent = label;
      if (stickyButton.disabled !== button.disabled) stickyButton.disabled = button.disabled;
    };
    const priceObserver = new MutationObserver(refresh), buttonObserver = new MutationObserver(refresh);
    if (price) priceObserver.observe(price, { childList: true, subtree: true });
    buttonObserver.observe(button, { attributes: true, attributeFilter: ['disabled'] });
    bar.cmCleanup = () => { observer.disconnect(); priceObserver.disconnect(); buttonObserver.disconnect(); };
    refresh();
  }
  document.addEventListener('click', async event => {
    const target = event.target;
    const opener = target.closest('[data-cm-open]');
    if (opener) {
      event.preventDefault();
      if (opener.dataset.cmMenuGroup) { const group = $(`[data-menu-group="${opener.dataset.cmMenuGroup}"]`); if (group) group.open = true; }
      openDialog(opener.dataset.cmOpen, opener); return;
    }
    const close = target.closest('[data-cm-close]'); if (close) { closeDialog(close.closest('dialog')); return; }
    const modelButton = target.closest('[data-cm-model-value]');
    if (modelButton) {
      saveModel(modelByLabel(modelButton.dataset.cmModelValue));
      closeDialog($('#cm-model-dialog'));
      const select = $('.cm-product-nav__select-wrap select');
      const option = optionFor(select, effective.label);
      if (select && option) { location.assign(previewUrl(option.value)); return; }
      if (select && !option) { toast('Bu tasarım seçtiğin model için bulunmuyor. Uygun tasarımları keşfedebilirsin.'); return; }
      if ($('[data-cm-collection-heading][data-phone-models="true"]')) { window.CasemetaCollections?.setModel(effective); return; }
      fillRecommendations(); return;
    }
    if (target.closest('[data-cm-clear-model]')) {
      saveModel(null); closeDialog($('#cm-model-dialog'));
      if ($('[data-cm-collection-heading][data-phone-models="true"]')) { saveModel(modelByLabel('iPhone 18 Pro Max')); window.CasemetaCollections?.setModel(effective); }
      else if ($('[data-cm-all-products]')) saveModel(modelByLabel('iPhone 18 Pro Max'));
      else if ($('[data-cm-featured]')) location.reload();
      else fillRecommendations(); return;
    }
    const brand = target.closest('[data-cm-brand-choice]');
    if (brand) { $$('[data-cm-brand-choice]').forEach(b => b.setAttribute('aria-pressed', String(b === brand))); filterModels(); return; }
    const quick = target.closest('[data-cm-quick]'); if (quick) { openQuick(quick.dataset.cmQuick, quick, quick.dataset.cmSelection ? JSON.parse(quick.dataset.cmSelection) : {}); return; }
    const direct = target.closest('[data-cm-direct-add]'); if (direct) { addDirect(direct); return; }
    const add = target.closest('[data-cm-quick-add]'); if (add) { addQuick(add); return; }
    if (target.closest('[data-cm-confirm-product-model]')) { saveModel(modelByLabel(productModel())); $('[data-cm-product-model-note]').hidden = true; return; }
    if (target.closest('[data-cm-sticky-add]')) { if (confirmProductModel()) $('product-info product-form [name="add"]')?.click(); return; }
    const choose = target.closest('[data-cm-choose-type]');
    if (choose) { event.preventDefault(); try { sessionStorage.setItem('cm-type-return', JSON.stringify({ path: new URL(choose.href).pathname, y: scrollY })); } catch {} location.assign(previewUrl(choose.href)); return; }
    const product = target.closest('[data-cm-product-link]'); if (product) { productLink(product, event); return; }
    const designLink = target.closest('a[href]'); if (designLink) designUrl(designLink);
    const allLink = target.closest('[data-cm-all-link]');
    if (allLink && effective?.collection && /^iPhone\b/.test(effective.label)) {
      const url = previewUrl(effective.collection); url.searchParams.set('view','cm-all'); url.searchParams.set('sort_by','manual'); allLink.href = url.href;
    }
    const collection = target.closest('[data-cm-collection-link], [data-menu-phone]');
    if (collection && effective) { collection.href = modelUrl(collection.href, effective).href; }
  });
  // Capture before the existing navigation/form listeners, without replacing Customix.
  document.addEventListener('click', event => {
    const modelLink = event.target.closest('.cm-product-nav__model-link');
    if (modelLink) { const model = modelByLabel(modelLink.textContent); if (model) saveModel(model); }
    if (event.target.closest('product-info product-form [name="add"]') && !confirmProductModel()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('.cm-product-nav__select-wrap select')) { const model = modelByLabel(target.selectedOptions[0]?.textContent); if (model) saveModel(model); }
    if (target.matches('[data-cm-quick-axis]') && target.value) {
      if (target.dataset.cmQuickAxis === 'model') { const model = modelByLabel(target.selectedOptions[0].textContent); if (model) saveModel(model); }
      const selection = {...quickSelection, [target.dataset.cmQuickAxis]: true, options: Object.fromEntries($$('[data-cm-quick-variant-option]').map(s => [s.dataset.optionName, s.value]))};
      openQuick(target.value, null, selection);
    }
    if (target.matches('[data-cm-quick-variant-option]')) updateQuickVariant();
  }, true);
  function filterModels() {
    const query = ($('[data-cm-model-search]')?.value || '').toLocaleLowerCase('tr-TR');
    const brand = $('[data-cm-brand-choice][aria-pressed="true"]')?.dataset.cmBrandChoice || 'all';
    const iphoneOnly = !!$('[data-cm-all-products]');
    $$('[data-cm-brand-choice]').forEach(b => { b.hidden = iphoneOnly; });
    let count = 0;
    $$('[data-cm-model-value]').forEach(b => { b.hidden = !(b.dataset.cmModelValue.toLocaleLowerCase('tr-TR').includes(query) && (iphoneOnly ? /^iPhone\b/.test(b.dataset.cmModelValue) : (brand === 'all' || b.dataset.cmBrand === brand))); if (!b.hidden) count++; });
    $('[data-cm-model-empty]').hidden = count > 0;
  }
  document.addEventListener('input', e => { if (e.target.matches('[data-cm-model-search]')) filterModels(); });
  document.addEventListener('toggle', e => { if (e.target.matches('.cm-menu__groups>details') && e.target.open) $$('.cm-menu__groups>details').forEach(d => { if (d !== e.target) d.open = false; }); }, true);
  function start() {
    remembered = effective = modelByLabel(window.CasemetaDesignEncodedModel) || (remembered && modelByLabel(remembered.label)) || modelByLabel('iPhone 18 Pro Max');
    if (effective) saveModel(effective);
    initializeDialogs(); initializeRails(); initializeCollection(); paintModel(); initializeSticky();
    $$('a[href]').forEach(a => { const url = previewUrl(a.getAttribute('href')); if (url.origin === location.origin) a.href = url.href; });
    const footer = $$('.cm-footer details'); const wide = matchMedia('(min-width: 750px)');
    const footerLayout = () => footer.forEach(d => { d.open = wide.matches; }); footerLayout(); wide.addEventListener('change', footerLayout);
    if ($('[data-cm-other-designs]')) fillRecommendations();
    else {
      const featured = $('[data-cm-featured]');
      if (featured) { const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) { observer.disconnect(); fillRecommendations(); } }, { rootMargin: '200px' }); observer.observe(featured); }
    }
    try { const saved = JSON.parse(sessionStorage.getItem('cm-type-return')); if (saved?.path === location.pathname) { sessionStorage.removeItem('cm-type-return'); requestAnimationFrame(() => window.scrollTo(0, saved.y)); } } catch {}
  }
  function cleanupProduct(scope) {
    $$('[data-cm-rail],[data-cm-sticky]',scope).forEach(el=>el.cmCleanup?.());
    $$('[data-cm-product-case-picker]',scope).forEach(el=>el.cmPickerCleanup?.());
    $$('dialog[open]',scope).forEach(dialog=>dialog.close());
    if (!$('dialog[open]')) document.documentElement.style.overflow = '';
  }
  function refreshProduct() {
    initializeDialogs(); initializeRails(); initializeSticky();
    $$('product-info a[href],.cm-product-content a[href]').forEach(a=>{a.href=previewUrl(a.getAttribute('href')).href;});
    fillRecommendations();
  }
  window.CasemetaStorefront = { openQuick, saveModel, cleanupProduct, refreshProduct, caseImages };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', e => {
    initializeDialogs(e.target); initializeRails(e.target); initializeCollection(); initializeSticky();
    $$('a[href]', e.target).forEach(designUrl);
    if ($('[data-cm-other-designs],[data-cm-featured]', e.target)) fillRecommendations();
  });
  document.addEventListener('shopify:section:unload', e => { window.CasemetaCollections?.destroy(e.target); window.CasemetaAllProducts?.destroy(e.target); cleanupProduct(e.target); });
})();
